// The mono "provenance line" that lives at the footer of every detail
// page: ID, source, version, timestamp. Signals "this is an engineered
// artifact, not a templated page." Linear + Stripe do this.

import { cn } from "../lib/cn";

interface Field {
  label?: string;
  value: string;
}

interface Props {
  fields: Field[];
  className?: string;
}

export default function ProvenanceLine({ fields, className }: Props) {
  return (
    <div
      className={cn(
        "font-mono text-[11px] text-fg-subtle tabular-nums",
        "flex flex-wrap items-center gap-x-3 gap-y-1",
        className,
      )}
    >
      {fields.map((f, i) => (
        <span key={`${f.label ?? i}-${f.value}`} className="inline-flex items-baseline gap-1.5">
          {i > 0 && <span aria-hidden className="text-fg-subtle/50">·</span>}
          {f.label && <span className="text-fg-subtle/70">{f.label}</span>}
          <span className="text-fg-muted">{f.value}</span>
        </span>
      ))}
    </div>
  );
}
